/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Settings } from '@api/model';
import { IAction } from '../../models/IshAction';
import { GET_SETTINGS_FULFILLED } from 'src/js/redux/actions/PortalWebsite';

const Initial: Settings = {};

export const settingsReducer = (state: Settings = Initial, action: IAction): Settings => {
  switch (action.type) {
    case GET_SETTINGS_FULFILLED:
      return {
        ...state,
        ...action.payload
      };

    default:
      return {
        ...state
      };
  }
};
